import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ProjectDetails__project-name" }

import InnForm from "@/components/ds/form/Form.vue";
import { computed, PropType } from "vue";
import { Project } from "@/types";
import { projectToSlug } from "@/tools/projects";
import commonTools from "@/tools/common-tools";
import { useClientStore } from "@/stores/clients";
import { useEmployeeStore } from "@/stores/employees";
import InnSection from "@/components/general/Section.vue";
import InnInput from "@/components/ds/input/Input.vue";
import IconButton from "@/components/ds/icon-button/IconButton.vue";
import { useUiStore } from "@/stores/ui";
import ProjectCalculation from "@/components/pages/project/ProjectCalculation.vue";
import ProjectStatus from "@/components/pages/project/ProjectStatus.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectDetails',
  props: {
    project: {
        type: Object as PropType<Project>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const clientStore = useClientStore();
const employeeStore = useEmployeeStore();
const uiStore = useUiStore();

const config1 = {
    sections: [
        {
            items: [
                {
                    type: "select",
                    key: "clientId",
                    label: "Klant",
                    options: clientStore.list,
                    valueKey: "id",
                    labelKey: "name",
                },
                {
                    type: "select",
                    key: "user_id",
                    label: "Werknemer",
                    options: employeeStore.list,
                    valueKey: "id",
                    labelKey: "name",
                },
                {
                    type: "text",
                    key: "currency",
                    label: "Currency",
                },
                {
                    type: "checkbox",
                    key: "finished",
                    label: "Afgerond",
                },
            ],
        },
    ],
};

const config2 = {
    sections: [
        {
            items: [
                {
                    type: "number",
                    key: "year",
                    label: "Boekhoudjaar",
                },
            ],
        },
    ],
};

const slug = computed(() => {
    return projectToSlug(props.project, -1);
});

const copySlug = () => {
    commonTools.clipboard(slug.value);
    uiStore.message("Gekopieerd...");
};

const archiveProject = () => {
    props.project.projectStatus = 5;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(InnSection, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(InnInput, {
            modelValue: __props.project.projectName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.project.projectName) = $event)),
            placeholder: "Projectnaam"
          }, null, 8, ["modelValue"]),
          _createVNode(IconButton, {
            onClick: copySlug,
            "icon-id": "paperclip"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Kopieer slug: " + _toDisplayString(slug.value), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(InnSection, null, {
      default: _withCtx(() => [
        _createVNode(ProjectStatus, { project: __props.project }, null, 8, ["project"])
      ]),
      _: 1
    }),
    _createVNode(InnSection, null, {
      default: _withCtx(() => [
        _createVNode(IconButton, {
          "icon-id": "archive",
          onClick: archiveProject
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Project archiveren ")
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(InnForm, {
      config: config1,
      value: __props.project
    }, null, 8, ["value"]),
    _createVNode(InnSection, null, {
      default: _withCtx(() => [
        _createVNode(ProjectCalculation, { project: __props.project }, null, 8, ["project"])
      ]),
      _: 1
    }),
    _createVNode(InnForm, {
      config: config2,
      value: __props.project
    }, null, 8, ["value"])
  ], 64))
}
}

})